import { useLayoutEffect } from "react";
import { Link } from "react-router";
import loginLogo from "../assets/login-logo.png";
import { useHubBranding } from "../features/auth/useHubBranding";

export function NotFound() {
  useHubBranding("hub");
  useLayoutEffect(() => {
    document.body.className = "surface-hub";
  }, []);

  return (
    <main className="notfound">
      <img className="notfound-logo" src={loginLogo} alt="Infinity Information Technology Solutions LLC" />
      <p className="notfound-code" aria-hidden="true">404</p>
      <h1 className="display">Page not found</h1>
      <p className="notfound-text">The page you are looking for does not exist or has moved.</p>
      <Link className="btn btn-primary" to="/">
        Back to the dashboard
      </Link>
    </main>
  );
}
